<template>
  <div style="background-color: rgb(247, 247, 247);"
    class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <navStudent></navStudent>

    <div style="width: 5.2083rem;
    padding:.2604rem .9375rem .5208rem .9375rem;margin: 0 auto;background-color: #fff;">
      <img src="../../assets/Personback.png" alt=""
        style="width: .4167rem;height: .1458rem;position: relative; top: -0.2083rem;left: -0.2604rem;"
        @click="$router.go(-1);">
      <Jianli :tid="tid">
      </Jianli>

    </div>

  </div>
</template>

<script>
import Jianli from '../layout/Slookteacherjianli.vue'
import navStudent from '../layout/nav-student.vue';
export default {
  components: {
    Jianli,
    navStudent
  }, data() {
    return {
      tid: ''
    }
  },
  created() {
    const hash = this.$route.hash.slice(1);
    this.tid = hash;
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/studentlook.vue